var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoBlancRvb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 626.15 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2, .cls-3 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        opacity: .5;\n      }\n\n      .cls-3 {\n        opacity: .8;\n      }\n\n      .cls-4 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-5 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-6 {\n        fill: none;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    width: 626.15,
    height: 200
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    width: 626.15,
    height: 200
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m288.46,36.92h24.62v84.94c0,13.52-1.08,23.01-3.24,28.46-2.16,5.46-5.72,9.79-10.69,13.01-4.96,3.22-10.92,4.83-17.87,4.83-14.19,0-26.28-6.18-36.26-18.54l17.69-16.45c3.91,4.41,7.24,7.37,9.99,8.88,2.74,1.51,5.4,2.26,7.97,2.26s4.58-1.1,5.87-3.31c1.28-2.2,1.93-7.05,1.93-14.54V36.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m339.23,70h23.85v45.61c0,8.88.61,15.04,1.83,18.49,1.22,3.45,3.18,6.13,5.88,8.05,2.7,1.91,6.03,2.87,9.98,2.87s7.31-.94,10.07-2.83c2.76-1.88,4.81-4.66,6.14-8.31.99-2.73,1.48-8.56,1.48-17.49v-46.39h23.85v40.12c0,16.54-1.3,27.85-3.91,33.94-3.19,7.43-7.88,13.13-14.08,17.1-6.2,3.97-14.08,5.96-23.64,5.96-10.37,0-18.76-2.32-25.16-6.96-6.4-4.64-10.91-11.11-13.51-19.41-1.86-5.74-2.78-16.19-2.78-31.33v-39.43Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 443.85,
    y: 33.85,
    width: 23.85,
    height: 131.54
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m498.4,31.36c4.17,0,7.74,1.51,10.72,4.53,2.98,3.02,4.47,6.67,4.47,10.96s-1.48,7.85-4.43,10.84c-2.95,2.99-6.48,4.48-10.58,4.48s-7.83-1.53-10.81-4.57c-2.98-3.05-4.47-6.75-4.47-11.1s1.48-7.75,4.43-10.7c2.95-2.96,6.5-4.44,10.67-4.44m-12.25,39.41h23.85v94.62h-23.85v-94.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m601.54,70.77h23.85v94.62h-23.85v-10c-4.66,4.41-9.32,7.58-14,9.52-4.68,1.94-9.76,2.92-15.23,2.92-12.27,0-22.89-4.74-31.84-14.22-8.96-9.48-13.43-21.26-13.43-35.35s4.33-26.58,13-35.91c8.66-9.33,19.19-14,31.58-14,5.7,0,11.05,1.07,16.05,3.22,5,2.14,9.63,5.36,13.87,9.65v-10.44Zm-24.76,19.07c-7.34,0-13.44,2.6-18.3,7.79-4.86,5.19-7.29,11.85-7.29,19.97s2.47,14.91,7.42,20.19c4.94,5.28,11.03,7.92,18.26,7.92s13.65-2.6,18.56-7.79c4.91-5.19,7.37-11.99,7.37-20.41s-2.46-14.91-7.37-20.02c-4.91-5.1-11.13-7.66-18.65-7.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m148.46,168.46H19.95c-11.02,0-19.95-8.93-19.95-19.95V19.95C0,8.93,8.93,0,19.95,0h128.56c11.02,0,19.95,8.93,19.95,19.95v128.58c0,11.01-8.92,19.93-19.93,19.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m166.15,184.62H37.64c-11.02,0-19.95-8.93-19.95-19.95V36.1c0-11.02,8.93-19.95,19.95-19.95h128.56c11.02,0,19.95,8.93,19.95,19.95v128.58c0,11.01-8.92,19.93-19.93,19.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m183.85,199.23H55.34c-11.02,0-19.95-8.93-19.95-19.95V50.72c0-11.02,8.93-19.95,19.95-19.95h128.56c11.02,0,19.95,8.93,19.95,19.95v128.58c0,11.01-8.92,19.93-19.93,19.93"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBlancRvb);
export default __webpack_public_path__ + "static/media/Logo_Blanc_RVB.c7398f564a5d78b6dd1789bf3075d734.svg";
export { ForwardRef as ReactComponent };